import type { PropsWithChildren } from 'react';
import { Children as ReactChildren } from 'react';
import styled from 'styled-components';

interface LayoutListProps extends PropsWithChildren {
  compact: boolean;
}

export function LayoutList({ compact, children }: LayoutListProps) {
  return (
    <Container>
      {ReactChildren.count(children) > 0 &&
        ReactChildren.map(children, (child, index) => (
          <Item key={child.key || index} _compact={compact}>
            {child}
          </Item>
        ))}
    </Container>
  );
}

const Container = styled.div``;

const Item = styled.div<{
  _compact: boolean;
}>`
  ${Container} &:not(:last-child) {
    padding-bottom: ${({ _compact }) => (_compact ? 12 : 24)}px;
  }
`;
